import * as React from "react";
import { Accordion, Card } from "react-bootstrap";
import { connect } from 'react-redux';
import { showLinkPolicyModal } from "../../actions/modalActions";
import { navigateTo } from "../../actions/navigationActions";
import { newMobileClientCheck } from "../../actions/salesActions";
import { CAR_REGISTRATION, DASHBOARD, PERSONAL_INFO } from "../../routes/routes";
import KPBreadCrumb from "../KPBreadCrumb/KPBreadCrumb";
import './GetLifeInsurance.css';

class GetLifeInsurance extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loggedIn: this.props.auth.uid ? true : false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleShowComingSoon = this.handleShowComingSoon.bind(this);
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
        this.handleLinkMyLivinPolicy = this.handleLinkMyLivinPolicy.bind(this);
    }
    
    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleShowComingSoon() {
        this.props.dispatchShowComingSoon();
    }
    
    handleLinkMyLivinPolicy() {
        this.props.dispatchShowLinkPolicyModal();
    }

    handleRedirect() {
        var nextPage = PERSONAL_INFO;
        if (this.props.profile.policyId !== "") {
            nextPage = CAR_REGISTRATION;
            this.props.dispatchCreditHistoryCheck();
        }
        this.props.redirectTo(nextPage);
    }

    handleAccordianArrow(e: any) {
        switch (e) {
            case 1:
                this.setState({ eventKey1Open: !this.state.eventKey1Open })
                this.setState({ eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 2:
                this.setState({ eventKey2Open: !this.state.eventKey2Open })
                this.setState({ eventKey1Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 3:
                this.setState({ eventKey3Open: !this.state.eventKey3Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 4:
                this.setState({ eventKey4Open: !this.state.eventKey4Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 5:
                this.setState({ eventKey5Open: !this.state.eventKey5Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 6:
                this.setState({ eventKey6Open: !this.state.eventKey6Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 7:
                this.setState({ eventKey7Open: !this.state.eventKey7Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 8:
                this.setState({ eventKey8Open: !this.state.eventKey8Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey9Open: false })
                break;
            case 9:
                this.setState({ eventKey9Open: !this.state.eventKey9Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false })
                break;
            default:
        }
    }
    
    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]
        return (
            <>
                <div className={(this.state.loggedIn ? "logged-in" : "logged-out") + " get-life-insurance"}>
                    <div className="livin-log-container">
                        <div className={"container-fluid new-page-margins"}>
                            <div className="new-breadcrumbwrapper breadcrumb-wrapper-claims-actual">
                                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Livin' policy" />
                            </div>
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <div id="GetLifeInsuranceBanner" className="content-box-padding-20px get-life-insurance__policy">
                                        <div className="row noma">
                                            <div className="col-12 col-lg-8 get-life-insurance__banner text-left nopa">
                                                <img src="./images/OnlineQuotes/LifeInsurance/life-insurance-heart-2.png" alt="Livin' policy" title="Livin' policy" />
                                                <h2 className="my-3">Livin' policy</h2>
                                                <h4 className="mb-3">Insure life, ensure livin'</h4>
                                                <p>With the king's livin' cover, you can rest easy knowing that you and your loved 1's will be taken care of no matter the loss or challenge</p>
                                                <div className="row m-0 text-center justify-content-start flex-column flex-sm-row align-content-start">
                                                    <div className="text-center text-lg-left mr-3">  <button className="btn btn-solid-green mt-3 mb-2" onClick={this.handleRedirect}>Get a quote</button></div>
                                                    <div className="text-center text-lg-left mr-3">  <button className="btn btn-outline-red mt-3 mb-2" onClick={this.handleLinkMyLivinPolicy}>Link my livin' policy</button></div>
                                                </div>
                                                <hr className="d-lg-none" />
                                            </div>

                                            <div className="col-12 col-lg-4 text-left nopa">
                                                <h5>Livin' benefits</h5>
                                                <div className="li-list">
                                                    <ul className="the-kings-life-benefits">
                                                        <li><span>No comprehensive medical exam needed</span></li>
                                                        <li><span>Tailor-made cover</span></li>
                                                        <li><span>Quick and easy claims</span></li>
                                                        <li><span>Full risk assessment</span></li>
                                                        <li><span>Lifelong cover</span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 nopa get-life-insurance__offer">
                                    <div className="content-box-padding-20px">
                                        <h3>Livin' products</h3>

                                        <div className="border-bottom row align-items-center flex-nowrap noma get-life-insurance__product-block">
                                            <div className="text-center d-inline-block get-life-insurance__img-block nopa">
                                                <img className="d-block get-life-insurance__img" src="./Images/OnlineQuotes/LifeInsurance/icon-life-insurance-cover.png" alt="Life Insurance" title="Life Insurance" />
                                            </div>

                                            <div className="d-inline-block">
                                                <h4>Life insurance</h4>
                                                <p>
                                                    Look after your family's future and get up to R10 million life cover, no waiting period
                                                </p>
                                            </div>

                                        </div>

                                        <div className="border-bottom row align-items-center flex-nowrap noma get-life-insurance__product-block">
                                            <div className="text-center d-inline-block get-life-insurance__img-block nopa">
                                                <img className="d-block get-life-insurance__img" src="./Images/OnlineQuotes/LifeInsurance/icon-disability-cover.png" alt="Disability Cover" title="Disability Cover" />
                                            </div>

                                            <div className="d-inline-block">
                                                <h4 className="">Disability cover</h4>
                                                <p>
                                                    Our disability cover pays out a lump sum if you're totally and permanently unable to perform your insured (or a similar) occupation
                                                </p>
                                            </div>
                                        </div>

                                        <div className="border-bottom row align-items-center flex-nowrap noma get-life-insurance__product-block">
                                            <div className="text-center d-inline-block get-life-insurance__img-block nopa">
                                                <img className="d-block get-life-insurance__img" src="./Images/OnlineQuotes/LifeInsurance/icon-salary-protection.png" alt="Income Protection" title="Income Protection" />
                                            </div>

                                            <div className="d-inline-block">
                                                <h4 className="">Income protection</h4>
                                                <p>
                                                    If you're unable to work due to disability, injury, or illness, we'll cover your financial commitments by paying out a percentage of your salary
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row align-items-center flex-nowrap noma get-life-insurance__product-block">
                                            <div className="text-center d-inline-block get-life-insurance__img-block nopa">
                                                <img src="./Images/OnlineQuotes/LifeInsurance/icon-critical-illness-cover.png" alt="Critical Illness" title="Critical Illness" />
                                            </div>

                                            <div className="d-inline-block">
                                                <h4 className="">Critical illness</h4>
                                                <p>
                                                    Whether you have a stroke, heart attack, undergo heart surgery, or are diagnosed with cancer.. Our critical illness insurance will ensure that you get the financial boost you need
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 nopa get-life-insurance__faq">
                                    <div className="content-box-padding-20px">
                                        <h3>FAQs</h3>

                                        <div className="row noma">
                                            <div className="col-12 nopa">
                                                <Accordion>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => this.handleAccordianArrow(1)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                    Do I have to do a medical exam?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey1Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="1">
                                                            <Card.Body>
                                                                <p>
                                                                    Nope, you're not dreaming... We don't ask for a comprehensive medical test (you may need to go for a small finger-prick test though).
                                                                </p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => this.handleAccordianArrow(2)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                   What type of cover does King Price offer?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey2Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="2">
                                                            <Card.Body>
                                                                <p>With the king, you can get life insurance, critical illness cover, disability cover and income protection cover</p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="3" onClick={() => this.handleAccordianArrow(3)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                    How much does it cost?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey3Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="3">
                                                            <Card.Body>
                                                                <p>This is the cool part... Depending on your salary and medical history we offer you specific packages that are suited to your needs, and budget. You can also create your own package.</p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="4" onClick={() => this.handleAccordianArrow(4)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                    Do I need life insurance?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey4Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="4">
                                                            <Card.Body>
                                                                <p>
                                                                    No one knows what tomorrow holds... So it's best to put a plan in place that will take care of your family's finances if you're ever not around. With life insurance, you can essentially ensure that your loved ones will be well looked after if this happens.
                                                                </p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="5" onClick={() => this.handleAccordianArrow(5)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                    Can I cancel anytime?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey5Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="5">
                                                            <Card.Body>
                                                                <p>Yes! We won't be mad (just a bit sad).</p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="6" onClick={() => this.handleAccordianArrow(6)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                    Who can apply?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey6Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="6">
                                                            <Card.Body>
                                                                <p>Healthy South African citizens between the ages of 18 and 60. You may also still qualify for our cover, despite some health issues like heart disease.</p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="7" onClick={() => this.handleAccordianArrow(7)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                    Can I buy life insurance for a loved one?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey7Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="7" onClick={() => this.handleAccordianArrow(1)}>
                                                            <Card.Body>
                                                                <p>
                                                                    Yes, they'll have to complete the quote form themselves, but the premium amount can be paid via your bank account.
                                                                </p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="8" onClick={() => this.handleAccordianArrow(8)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                    Will my premium change over time?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey8Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="8">
                                                            <Card.Body>
                                                                <p>Our quote process enables you to choose how you want your premium to increase over time.</p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="9" onClick={() => this.handleAccordianArrow(9)}>
                                                            <div className="row align-items-center">
                                                                <div className="col get-life-insurance__accordion-text">
                                                                    What happens when I pass away?
                                                                </div>
                                                                <div className={"accordion-arrow-svg" + (this.state.eventKey9Open ? ' isRotatednew' : '')}></div>
                                                            </div>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="9">
                                                            <Card.Body>
                                                                <p>We'll either pay out a lump-sum or make monthly payments to your beneficiary.</p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="get-life-insurance__get-quote-block d-none">
                    <button className="btn btn-solid-green get-life-insurance__get-quote-big">Get a quote</button>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchCreditHistoryCheck: () => dispatch(newMobileClientCheck("", true, null)),
        dispatchShowLinkPolicyModal: () => dispatch(showLinkPolicyModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GetLifeInsurance);